import React from "react";
import ScanContent from "widgets/ScanContent";
import s from "./style.module.scss";

const Scan: React.FC = () => {
  return (
    <main className={s.main}>
      <ScanContent />
    </main>
  );
};

export default Scan;
